export default {
    cartItemListData: [],
    isLoaded: true,
};
